import React from "react";

export const VERBOSITY_LEVELS = [
  { value: 0, label: "Brief", description: "Two or three sentences" },
  { value: 1, label: "Standard", description: "A focused answer" },
  { value: 2, label: "Detailed", description: "Comprehensive, with examples" },
];

/**
 * Answer length, as a segmented control in the composer footer.
 *
 * Replaces the full-width slider that sat above the input. A slider implies a
 * continuous range; this setting has exactly three values, so a segmented
 * control tells the truth about it and takes a third of the space. Built as a
 * real radiogroup so arrow keys and screen readers work.
 */
export default function VerbosityToggle({ value = 1, onChange }) {
  const handleKeyDown = (event) => {
    const delta =
      event.key === "ArrowRight" || event.key === "ArrowDown"
        ? 1
        : event.key === "ArrowLeft" || event.key === "ArrowUp"
        ? -1
        : 0;
    if (!delta) return;
    event.preventDefault();
    const next = Math.min(2, Math.max(0, value + delta));
    if (next !== value) onChange?.(next);
  };

  return (
    <div
      role="radiogroup"
      aria-label="Answer length"
      onKeyDown={handleKeyDown}
      className="flex items-center gap-0.5 rounded-lg bg-iq-rail p-0.5"
    >
      {VERBOSITY_LEVELS.map((level) => {
        const selected = value === level.value;
        return (
          <button
            key={level.value}
            type="button"
            role="radio"
            aria-checked={selected}
            tabIndex={selected ? 0 : -1}
            title={level.description}
            onClick={() => onChange?.(level.value)}
            className={`rounded-[7px] px-2.5 py-1 text-[12px] font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-iq-brand ${
              selected
                ? "bg-white text-iq-ink shadow-sm"
                : "text-iq-ink-soft hover:text-iq-ink"
            }`}
          >
            {level.label}
          </button>
        );
      })}
    </div>
  );
}
